
/**
 * Escape regexp special characters in `str`.
 *
 * @param {String} str
 * @return {String}
 * @api public
 */

module.exports = function(str){
  return String(str).replace(/([.*+?=^!:${}()|[\]\/\\])/g, '\\$1');
};


//////////////////
// WEBPACK FOOTER
// ./~/escape-regexp-component/index.js
// module id = 428
// module chunks = 168707334958949